var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"height":_vm.UI.clientWidth / 3 + 'px'}},_vm._l((_vm.headPics),function(item,index){return _c('el-carousel-item',{key:item.src},[_c('img',{staticClass:"full-width",class:item.url ? 'cursor-pointer' : '',attrs:{"src":item.src},on:{"click":function($event){return _vm.toUrl(item.url)}}})])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cf993c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/home/headPic.vue
// module id = null
// module chunks = 